module.exports = __webpack_public_path__ + "static/img/tab2.ad7ebeee.png";